<template>
  <div class="login-container">
    <el-form
      :model="loginForm"
      :rules="rules"
      status-icon
      ref="loginForm"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
      <h3 class="title" style="padding: 10px 0;">证书查询登录后台</h3>
      <el-form-item prop="username">
        <el-input
          type="text"
          v-model="loginForm.username"
          auto-complete="off"
          placeholder="用户名"
          @keyup.enter.native="handleSubmit"
        >
          <template slot="prepend">
            <icon name="user" :w="26" :h="26"></icon>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          show-password
          v-model="loginForm.password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleSubmit"
        >
          <template slot="prepend">
            <icon name="password" :w="23" :h="23"></icon>
          </template>
        </el-input>
      </el-form-item>
      <el-checkbox v-model="checked" class="rememberme">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click="handleSubmit" :loading="logining">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logining: false,
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: false
    }
  },
  methods: {
    handleSubmit(event) {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.logining = true
          let token = sessionStorage.getItem('token') // 获取本地存储的token
          if (token === '' || token === null) {
            this.$http({
              method: 'post',
              url: '/api/user/login',
              data: this.loginForm
            })
              .then(res => {
                var json = res.data
                if (json.code === 200) {
                  this.$store.commit('ADD_TOKEN', json.data.access_token)
                  this.$store.commit('ADD_USERID', json.data.id)
                  this.$message.success('登录成功!')
                  this.$router.push('/datalist')
                  this.logining = false
                } else {
                  this.$message.error(json.msg)
                  this.logining = false
                }
              })
              .catch(err => {
                this.$message.error('登录失败，错误：' + err)
              })
          } else {
            this.$router.push('/datalist')
            this.$message.success('登录成功!')
            this.logining = false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100%;
}
.login-page {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  margin: 160px auto;
  width: 350px;
  padding: 35px 35px 15px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}
.login-container .title {
  text-align: center;
}
#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
